<template>

<CCard style=" display: flex;" >      
    <CCardHeader style=" display: flex;justify-content: center;"><h2>{{ eheader }}</h2></CCardHeader>
    <CCardBody class="signature-container"  style=" display: flex;">       
        <ejs-signature id="signature" width="600px" height="300px"  :change="change" style="display: flex;justify-content: center; "></ejs-signature>  
    </CCardBody>   
    <CCardFooter style="text-align: right;">   
        <span class="e-btn-options">
            <ejs-button id="signsave" cssClass="e-primary e-sign-save" disabled="true" v-on:click.native="BtnClick">儲存</ejs-button>
            <ejs-button id="signclear" cssClass="e-primary e-sign-clear" disabled="true" v-on:click.native="clearBtnClick">清除</ejs-button>
        </span>
      <!--<ejs-button cssClass="e-flat" style="font-weight: 700;font-size: 16px;font-style: normal;color: #ff5733;" v-on:click.native='submit'>儲存</ejs-button>-->
    </CCardFooter> 
  </CCard>



</template>
    
    <script>
        import Vue from "vue";
    import { SignatureComponent } from "@syncfusion/ej2-vue-inputs";
    import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";
    import { getComponent } from "@syncfusion/ej2-base";
    
    export default {
      data: function () {
        return {
            eheader:"",
            rowdata:[],
        };
      },
      components: {
        "ejs-button": ButtonComponent,
        "ejs-signature": SignatureComponent,
      },
        mounted() {
            this.$eventHub.$on('SetHeader', this.Header);
            this.$eventHub.$on('sign', this.onCreator);
            // this.$eventHub.$on('report', this.onReport);
        },
        beforeDestroy() {
            this.$eventHub.$off('sign');
            this.$eventHub.$off('SetHeader');
        },
      methods: {
        Header(h){
            this.eheader=h;
            this.clearBtnClick();
        },
        onCreator(e) {
        // 收到 payload e，這裡處理
            console.log("datarow",e);
            this.rowdata=e;
            this.getbase64(e)
        },
        submit:function() {
            this.$emit('onSignClose');
        },
        getbase64: function(args) {
            var signature = getComponent(document.getElementById('signature'), 'signature');
            this.axios({
                method: 'get',
                baseURL: Vue.prototype.GLOBAL.baseURL,
                url: `/Account/Sign?userid=${args.user_name}`,
                headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },

            })
            .then((response) => {       
                if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
                console.log(response.data.datas);
                if(response.data.datas == null){
                    return;
                }
                signature.load("data:image/png;base64," + response.data.datas);
                this.change();
            })
            .catch((error) => { 
                this.showError(error, true) }
            )                 
           
        },
        BtnClick: function() {
            var signature = getComponent(document.getElementById('signature'), 'signature');
            this.axios({
                method: 'post',
                baseURL: Vue.prototype.GLOBAL.baseURL,
                url: `/Account/SaveSign`,
                headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
                data:{
                    AccountId:this.rowdata.user_name,
                    base64:signature.signatureValue,
                }
            })
            .then((response) => {       
                if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
                this.$emit('onSignClose');
            })
            .catch((error) => { 
                this.showError(error, true) }
            )                 
           
        },
        clearBtnClick: function() {
            var signature = getComponent(document.getElementById('signature'), 'signature');
            var saveBtn = getComponent(document.getElementById('signsave'), 'btn');
            var clearBtn = getComponent(document.getElementById('signclear'), 'btn');
            signature.clear();
            if (signature.isEmpty()) {
                saveBtn.disabled = true;
                clearBtn.disabled = true;
            }
        },
        change: function() {
            var signature = getComponent(document.getElementById('signature'), 'signature');
            var saveBtn = getComponent(document.getElementById('signsave'), 'btn');
            var clearBtn = getComponent(document.getElementById('signclear'), 'btn');
            if (!signature.isEmpty()) {
                saveBtn.disabled = false;
                clearBtn.disabled = false;
            }
        }
           
        }
    }
    </script>
    
    <style scoped>

    #signature-control h4 {
        margin-bottom: 20px;
        text-align: center;
    }
    
    #signdescription {
        font-size: 14px;
        padding-bottom: 10px;
    }
    
    .e-sign-clear {
        margin-left: 5px;
    }
    
    .e-btn-options {
        float: right;
        margin-bottom: 10px;
    }
    
    #signature-control {
        height: 300px;
        width: 100%;
        margin: 0;
    }
    
    .e-bigger #signature-control h4 {
        font-size: 20px;
    }
    
    </style>